function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.111 22h2.445v-7.333H17.11V22zM2.444 22H4.89V9.778H2.444V22zM22 9.778h-2.444V0H17.11v9.778h-2.444v2.444H22V9.778zM7.333 17.11h2.445V22h2.444v-4.889h2.445v-2.444H7.333v2.444zM12.223 0H9.777v12.222h2.444V0zm-4.89 7.333V4.89H4.89V0H2.444v4.889H0v2.444h7.333z",
  fill: "currentColor"
});

function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "c88711cf68b49f3199f9656400e0bdf6.svg";
export { SvgFilters as ReactComponent };